import {environment} from '../../environments/environment';
import {Const} from './const.model';

export class Conf extends Const {

  public static SM_URL = environment.serverStage ? Conf.SM_URL_STAGE : Conf.SM_URL_PROD;
  public static PR_LOGIN_URL = environment.serverStage ? Conf.PR_LOGIN_URL_STAGE : Conf.PR_LOGIN_URL_PROD;

}
